/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AwsS3TestReq } from '../../models/aws-s-3-test-req';

export interface ApiServerTestTryAwsS3Post$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
      body?: AwsS3TestReq
}

export function apiServerTestTryAwsS3Post(http: HttpClient, rootUrl: string, params?: ApiServerTestTryAwsS3Post$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiServerTestTryAwsS3Post.PATH, 'post');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiServerTestTryAwsS3Post.PATH = '/api/server-test/try-aws-s3';
